import { render } from "./DashboardCardWidget.vue?vue&type=template&id=01dcce35&scoped=true"
import script from "./DashboardCardWidget.vue?vue&type=script&lang=js"
export * from "./DashboardCardWidget.vue?vue&type=script&lang=js"

import "./DashboardCardWidget.vue?vue&type=style&index=0&id=01dcce35&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01dcce35"]])

export default __exports__